import React, { useState, useEffect, useContext, useCallback } from "react";

import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";
import UnlockShiptoManagementAPI from "apis/UnlockShiptoManagement/UnlockShiptoManagement";
import Context from "context/context";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": { color: "#D3D3D3" },
    "& .MuiFormLabel-root": { color: "#707070" },
    "& .MuiInputBase-input": { color: "#707070" },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#707070" },
      "&:hover fieldset": { borderColor: "#707070" },
      "&.Mui-focused fieldset": { borderColor: "#707070" },
      borderRadius: 20,
      marginTop: 0,
    },
  },
})(TextField);

export default function Screen1AccountLookup() {
  const { dispatch } = useContext(Context);

  const { createShipto } = UnlockShiptoManagementAPI();

  const history = useHistory();
  const classes = styles();
  const { t } = useTranslation();

  const [shipto, setShipto] = useState("");
  const [loading, setLoading] = useState(false);

  // Dialog state
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
    const [dialogData, setDialogData] = useState(null);


  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Unlock Account Management", "Create"],
    });
  }, [dispatch]);

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  const handleLookup = useCallback(async () => {
    if (!shipto.trim()) {
      toast.error("Customer Account Number is required");
      return;
    }

    setLoading(true);

    try {
      const res = await createShipto({
        shipto: shipto.trim(),
      });

      console.log("LOOKUP RESPONSE:", res);

      // Popup condition
      if (res?.success === true && res?.popup === true) {
        setDialogMessage(res?.message || "");
        setDialogData(res.data);
        setOpenDialog(true);
        setDialogData(res.data);
        return;
      }

      // Normal success
      if (res?.success === true && res?.data) {
        history.replace("/dashboard/unlock-create-details", {
          customerData: res.data,
        });
        return;
      }

      if (res?.success === false) {
        toast.error(res?.message || "Customer account not found");
        return;
      }

      console.error("Unexpected lookup response:", res);
      toast.error("Unexpected response — check console for details");
    } catch (e) {
      console.error("LOOKUP ERROR:", e);
      toast.error(
        e?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }, [shipto, createShipto, history]);

  // Yes
  const handleDialogYes = () => {
    setOpenDialog(false);

    history.replace("/dashboard/unlock-create-details", {
     customerData: dialogData,
    });
  };

  // No
  const handleDialogNo = () => {
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      {/* Header */}
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton onClick={() => history.goBack()}>
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>

          <span
            style={{
              fontSize: 18,
              fontWeight: "bold",
            }}
          >
            {t("Create")}
          </span>
        </Grid>
      </Grid>

      {/* Form */}
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <span
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: "#333",
            }}
          >
            {t("Enter Customer Location Number")}
          </span>
        </Grid>

        <Grid item xs={3}>
          <CssTextField
            label={t("Customer Account Number")}
            fullWidth
            value={shipto}
            onKeyDown={(e) => {
              blockInvalidChar(e);

              if (e.key === "Enter") {
                handleLookup();
              }
            }}
            onChange={(e) =>
              setShipto(e.target.value.replace(/\D/g, ""))
            }
          />
        </Grid>

        <Grid
          item
          xs="auto"
          style={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Button
            className={classes.submitBtn}
            disabled={loading}
            onClick={handleLookup}
            startIcon={
              loading ? (
                <CircularProgress
                  size={14}
                  style={{ color: "#fff" }}
                />
              ) : null
            }
          >
            {loading ? "Looking up..." : t("Lookup")}
          </Button>
        </Grid>
      </Grid>

      {/* Confirmation Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleDialogNo}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Enrollment Confirmation
        </DialogTitle>

        <DialogContent>
          <div style={{ marginBottom: 15 }}>
            {dialogMessage}
          </div>

          <div style={{ fontWeight: 600 }}>
            Do you want to enroll?
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogNo}>
            No
          </Button>

          <Button
            onClick={handleDialogYes}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}